import { createContext } from 'react';

import { ITabsContext } from './interfaces/ITabsContext';

export const TabContext = createContext<ITabsContext>({});
